
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.385 19.567l-5.3-5.3 5.3-5.3c.6-.6.2-3.7-.7-2.7l-6.3 6.3-6.4-6.4c-.9-.9-1.3 2.1-.7 2.7l5.3 5.3-5.3 5.3c-.6.6-.2 3.7.7 2.7l6.3-6.3 6.3 6.3c1 1 1.4-2 .8-2.6z"}})])
          )
        }
      }
    